import { useState } from "react";
import { Button, Colors, Icon, Switch } from "@blueprintjs/core";
import { Box, CustomButton, CustomPopover, useDarkMode, useToggle } from "ui-components";
import useSession from "ui-io/use-session";
import styled from "styled-components";
import { Avatar } from "../../common";
import { useNavigate } from "react-router-dom";
import SearchCompany from "./search-company";
import AIChatWindow from "../../common/ai-chat/ai-chat-window";
const DashboardHeader = () => {
  const [darkMode, setDarkMode] = useDarkMode();
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [isAIWindowOpen, setToggleAIWindow] = useToggle(false);
  return (
    <>
    <AIChatWindow isAIWindowOpen={isAIWindowOpen} setToggleAIWindow={setToggleAIWindow} />
    <CustomHeader className="header">
      {/* <SearchBar>
        <input type="text" placeholder="Search for something" />
        <SearchIcon>
          <img src="/icons/search.svg" alt="search" height={15} width={15} />
        </SearchIcon>
      </SearchBar> */}
      <SearchCompany />
      <Box flexDir="row" items="center">
        <CustomButton onClick={() => setToggleAIWindow()} className="w-100 mr-md">
          <div className="display-flex align-center">
            <Icon icon="chat" size={12} />{" "}
            <span className="ml-xs">Agent X</span>
          </div>
        </CustomButton>
        <Switch
          style={{ marginBottom: 0, marginRight: "7px" }}
          innerLabelChecked="🌙"
          innerLabel="☀️"
          checked={darkMode}
          onChange={() => setDarkMode((prev: boolean) => !prev)}
        />

        <CustomPopover
          isOpen={isProfileOpen}
          content={<ProfileContent />}
          placement="bottom-end"
          interactionType="click"
          handleInteraction={(val) => {
            setProfileOpen(val);
          }}
        >
          <div className="cursor-pointer">
            <Avatar
              profileUrl={"/images/profile.svg"}
              displayName={"Kishan Madan"}
              email={"yantrix@gmail.com"}
              isCircle={true}
              isCurrentUser={false}
              isLoading={false}
              size={"30px"}
            />
          </div>
        </CustomPopover>
      </Box>
    </CustomHeader>
    </>
  );
};

export default DashboardHeader;

const ProfileContent = () => {
  const {session, logout } = useSession();
  const navigate = useNavigate();
  return (
    <Box pt={"medium"}>
      <Box
        textAlign="left"
        flexDir="col"
        pb={"medium"}
        pl={"medium"}
        pr={"medium"}
      >
        <span className="fs-16 fw-bold">{session?.name || session?.username || session?.userId ||  "John Smith"}</span>
        <span className="fs-12">{session?.email || "johnsmith@gmail.com"}</span>
      </Box>
      <Button onClick={() => navigate("/profile")} className="w-100">
        <div className="display-flex align-center">
          <Icon icon="user" size={12} />
          <span className="ml-xs">Profile </span>
        </div>
      </Button>
      <Button onClick={() => logout()} className="w-100">
        <div className="display-flex align-center">
          <Icon icon="log-out" size={12} />{" "}
          <span className="ml-xs">Logout</span>
        </div>
      </Button>
    </Box>
  );
};

const CustomHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY2 : Colors.WHITE};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5};
  border-radius: 25px;
  padding: 5px 15px;
  width: 50%;
  height: 40px;
  position: relative;

  input {
    border: none;
    height: 40px;
    background-color: ${({ theme: { darkMode } }) =>
      darkMode ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5};
    color: ${({ theme: { darkMode } }) =>
      darkMode ? Colors.GRAY5 : Colors.GRAY1};
    &::placeholder {
      color: ${({ theme: { darkMode } }) =>
        darkMode ? Colors.GRAY5 : Colors.GRAY1};
    }
    width: 100%;
    padding-left: 30px;
    font-size: 16px;
    &:focus {
      outline: none;
    }
  }
`;
const SearchIcon = styled.span`
  position: absolute;
  left: 15px;
  display: flex;
  align-items: center;
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.LIGHT_GRAY5 : Colors.LIGHT_GRAY5};
  filter: ${({ theme: { darkMode } }) =>
    darkMode ? "grayscale(100%) invert(1)" : "none"};
`;
